export default __webpack_public_path__ + "static/media/waste-water.01e72a02.jpg";